import { jsx as e } from "react/jsx-runtime";

import { TableHeader as t } from "react-aria-components";

import a from "../../../../utils/classNames/index.js";

const s = ({children: s, className: o, ...r}) => e(t, {
    ...r,
    className: a("outline-b sticky top-0 z-[1] bg-white outline-offset-1 outline-neutral-300", o),
    children: s
});

export { s as default };
//# sourceMappingURL=index.js.map
